'use client'

import { createContext } from 'react'

import { ProfileSettingsContextType } from '../../types'

const ProfileSettingsContext = createContext<ProfileSettingsContextType | null>(null)

export default ProfileSettingsContext
